/**
 * Abstract class for visiting the AbstractRuleModel hierarchy.
 *
 * @abstract
 */
export default class AbstractRuleModelVisitor {
	visit(ruleModel) {
		return ruleModel.accept(this);
	}

	visitAbstractRuleModel(_ruleModel) {}

	visitBalanceRuleModel(ruleModel) {
		return this.visitAbstractRuleModel(ruleModel);
	}

	visitManualEntryRuleModel(ruleModel) {
		return this.visitAbstractRuleModel(ruleModel);
	}

	visitManualJournalEntryRuleModel(ruleModel) {
		return this.visitAbstractRuleModel(ruleModel);
	}

	visitAbstractPredictionRuleModel(ruleModel) {
		return this.visitAbstractRuleModel(ruleModel);
	}

	visitLinearRegressionPredictionRuleModel(ruleModel) {
		return this.visitAbstractPredictionRuleModel(ruleModel);
	}

	visitSingularSpectrumAnalysisRuleModel(ruleModel) {
		return this.visitAbstractPredictionRuleModel(ruleModel);
	}

	visitConstantPredictionRuleModel(ruleModel) {
		return this.visitAbstractPredictionRuleModel(ruleModel);
	}

	visitFromBudgetPredictionRuleModel(ruleModel) {
		return this.visitAbstractPredictionRuleModel(ruleModel);
	}

	visitFromActualsPredictionRuleModel(ruleModel) {
		return this.visitAbstractPredictionRuleModel(ruleModel);
	}

	visitSeasonalTrendPredictionRuleModel(ruleModel) {
		return this.visitAbstractPredictionRuleModel(ruleModel);
	}
}
